module.exports = __webpack_public_path__ + "img/ics_o_destination.9c45551b.svg";